import { DurationDisplay } from '@components/DurationDisplay'
import { type Duration, durationList } from '@hvf/contracts'
import type { Component } from 'solid-js'
import { useService } from 'solid-services'
import { useFilters } from '../state/filter'
import { FilterSelect } from './FilterSelect'

const DurationFilter: Component = () => {
  const { filters, setDuration } = useService(useFilters)()

  return (
    <FilterSelect
      label="Pattern Candlestick Time Frame"
      items={durationList}
      selected={filters().duration}
      onChange={setDuration}
      formatTriggerText={(text) =>
        text.replace('intraday', '< Daily').replace('multiday', 'Daily +')
      }
      itemTemplate={(value) => <DurationDisplay duration={value as Duration} />}
    />
  )
}

export default DurationFilter
